import useSWR from "swr";
import fetcher from "utils/fetcher";
import parsePageNr from "utils/parsePageNr";
import queryString from "query-string";
import { getCookie } from "cookies-next";

const useListings = ({ query }) => {
  const cookie = getCookie("geo_location");
  const { page } = query;
  const pageNr = parsePageNr(page);
  let queryObject = {};

  // If no location is given, show nearby accommodations
  const coords = cookie ? cookie.split(",") : null;
  if (coords !== null && coords[0] !== "0" && coords[1] !== "0") {
    Object.assign(queryObject, { lat: coords[0], lon: coords[1] });
  }

  Object.keys(query).forEach((key) => {
    switch (key) {
      case "page":
        Object.assign(queryObject, { page: pageNr });
        break;
      default:
        Object.assign(queryObject, { [key]: query[key].split("|") });
    }
  });
  queryObject = queryString.stringify(queryObject, {
    arrayFormat: "separator",
    arrayFormatSeparator: "|",
  });

  const { data, isLoading, error } = useSWR(
    `${process.env.NEXT_PUBLIC_LISTINGS_API_URL}/listings?${queryObject}`,
    fetcher,
    {
      keepPreviousData: true,
      revalidateOnFocus: true,
    }
  );

  return {
    listingResults: data?.listingResults,
    totalListings: data?.totalListings,
    countFilterResults: data?.countFilterResults,
    isLoading,
    isError: error,
  };
};

export default useListings;
